import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { Modal } from 'react-bootstrap';
import ratingImg from 'assets/img/Stars-Thumbs-Up.png';
import { USER_RATING } from '_constants';
import * as memberSelectors from '../../reducers/member.reducer';
import { dashboardActions, userprofileActions } from 'actions';
import _ from 'lodash';
import { DEVICE_TYPE } from '../../constants';

class AppStoreRating extends React.Component {
  static propTypes = {
    responseScore: PropTypes.number.isRequired,
    deviceType: PropTypes.number,
    getMember: PropTypes.func.isRequired,
    memberKey: PropTypes.string,
    getPersonSettings: PropTypes.func,
    updateAgentSettings: PropTypes.func
  };

  state = {
    show: false,
    redirectToStoreCount: 0,
    personSetting: {}
  }

  componentDidMount = async () => {
    const getMemberInfo = this.props.getMember(this.props.memberKey);
    const getPersonSettingInfo = this.props.getPersonSettings(this.props.memberKey);
    const response = await Promise.all([getPersonSettingInfo, getMemberInfo]);
    this.showPopUp(this.props.responseScore, response[0]);
  }

  showPopUp = (responseScore, personSettings) => {
    const appStoreRatingPopUpCount = _.get(personSettings, 'settings.appStoreSettings.appStoreRatingPopUpCount', 0);
    const hasAgentRedirectedToAppStore = _.get(personSettings, 'settings.appStoreSettings.hasAgentRedirectedToAppStore', false);

    if (!hasAgentRedirectedToAppStore && responseScore >= 90 && appStoreRatingPopUpCount < 5) {
      this.setState({
        show: true,
        redirectToStoreCount: appStoreRatingPopUpCount + 1,
        personSetting: personSettings
      });
    }
  }

  hideModal = () => {
    this.setState({
      show: false
    });
  }

  updateAgentPopUpCount = async () => {
    this.hideModal();
    const ps = Object.assign({}, this.state.personSetting);
    ps.settings.appStoreSettings.appStoreRatingPopUpCount = this.state.redirectToStoreCount;
    await this.props.updateAgentSettings(this.props.memberKey, ps);
  }

  redirectToStore = async () => {
    this.hideModal();
    const ps = Object.assign({}, this.state.personSetting);
    ps.settings.appStoreSettings.hasAgentRedirectedToAppStore = true;
    await this.props.updateAgentSettings(this.props.memberKey, ps);
    if (this.props.deviceType === DEVICE_TYPE.IOS) {
      window.location.href = USER_RATING.APP_STORE_URL;
    }
  }

  render () {
    return (
      <Modal centered autoFocus show={this.state.show} dialogClassName={'user-rating-modal'}>
        <Modal.Header className='message-background'>
          <img src={ratingImg} className='stars-thumbs-up' />
        </Modal.Header>
        <Modal.Body>
          <div className='enjoying-xome-pro'>{USER_RATING.RATING_BODY_HEADER}</div>
          <div className='user-rating-msg'>
            {USER_RATING.RATING_BODY_TEXT}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className={'btn btn-link no-thanks'} onClick={() => this.updateAgentPopUpCount()}> No Thanks </button>
          <button onClick={() => this.redirectToStore()} className={'btn btn-link sure'}> Sure </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const { member, userprofile } = state;
  const responseScore = _.get(memberSelectors.memberData(member), 'memberResponseOMeterScore', 0);
  const memberKey = _.get(userprofile, 'memberKey', '');
  return {
    responseScore,
    memberKey
  };
};

const mapDispatchToProps = dispatch => ({
  getMember: bindActionCreators(dashboardActions.getMember, dispatch),
  getPersonSettings: bindActionCreators(userprofileActions.getPersonSettings, dispatch),
  updateAgentSettings: bindActionCreators(userprofileActions.updateAgentSettings, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppStoreRating));
